window.TimeZone = (function () {

    const selectors = {
        timeZone: '#tz-select',
        authorizeLocalDateTime: '.LoginLocalDateTime'
    };

    return {
        init: function () {
            this.unbindUI();
            this.bindUI();
        },

        bindUI: function () {
            $(document).on('change.timezone', selectors.timeZone, function () {
                Ajax.postJson($(selectors.timeZone).data("ajaxurl"), {
                    data: { tzId: $(this).val() }
                });
                return false;
            });

            $(document).ready(function () {
                $(selectors.authorizeLocalDateTime).val(getLocalDateTimeOffsetString());
            });
        },
        unbindUI: function () {
            $(document).off('change.timezone', selectors.timeZone);
        }
    }

    function getLocalDateTimeOffsetString() {
        var date = new Date();
        return date.toISOString();
    }
}());
